// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pU4e","clinicsSelect":"styles_clinicsSelect__2-qYz"};